module.exports = __webpack_public_path__ + "img/ANTENNA 2 GREEN.6450144.svg";